"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __aws_sdk_bucket_endpoint_middleware = require("@aws-sdk/bucket-endpoint-middleware");
var __aws_sdk_middleware_header_default = require("@aws-sdk/middleware-header-default");
var __aws_sdk_middleware_stack = require("@aws-sdk/middleware-stack");
var ListBucketMetricsConfigurations_1 = require("../model/ListBucketMetricsConfigurations");
var ListBucketMetricsConfigurationsCommand = /** @class */ (function () {
    function ListBucketMetricsConfigurationsCommand(input) {
        this.input = input;
        this.model = ListBucketMetricsConfigurations_1.ListBucketMetricsConfigurations;
        this.middlewareStack = new __aws_sdk_middleware_stack.MiddlewareStack();
    }
    ListBucketMetricsConfigurationsCommand.prototype.resolveMiddleware = function (clientStack, configuration) {
        var handler = configuration.handler;
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {},
            model: this.model
        };
        stack.add(__aws_sdk_bucket_endpoint_middleware.bucketEndpointMiddleware({
            forcePathStyle: configuration.forcePathStyle,
            preformedBucketEndpoint: configuration.bucketEndpoint,
            useAccelerateEndpoint: configuration.useAccelerateEndpoint,
            useDualstackEndpoint: configuration.useDualstackEndpoint
        }), {
            step: "build",
            priority: 0
        });
        stack.add(__aws_sdk_middleware_header_default.headerDefault({
            "Content-Type": "application/octet-stream"
        }), {
            step: "build",
            priority: -50,
            tags: { "Content-Type": true }
        });
        return stack.resolve(handler(handlerExecutionContext), handlerExecutionContext);
    };
    return ListBucketMetricsConfigurationsCommand;
}());
exports.ListBucketMetricsConfigurationsCommand = ListBucketMetricsConfigurationsCommand;
//# sourceMappingURL=ListBucketMetricsConfigurationsCommand.js.map